// extracted by mini-css-extract-plugin
export default {"root":"styles_root__X7uF5","icon":"styles_icon__Mj2Oz","label":"styles_label__vT97n"};